// eslint-disable-next-line import/no-unresolved
import { AskAnalystModal, AskAnalystModalProps } from '@creditsights/creditsights-web';
import { useQueryClient } from 'react-query';

const AskAnalystModalWrapper = ({ onSuccess, setError, error, closeModal, subject }: AskAnalystModalProps): React.ReactElement => {
  const client = useQueryClient();
  return <AskAnalystModal client={client} onSuccess={onSuccess} setError={setError} error={error} closeModal={closeModal} subject={subject} />;
};

export default AskAnalystModalWrapper;
